import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { selectInDisplayContent } from '../../features/displayContent/selectors'
import { VisionSimulationContent } from '../../model/model'
import {
	FirstLine,
	ImagesBox,
	SecondLine,
	ThirdLine,
	TitleWrapper,
	Wrapper,
} from './CommonComponents'
import MediaBox from './MediaBox'

const isVisionSimulationContent = (
	content?: any,
): content is VisionSimulationContent => content?.section === 'visionSimulation'

export const VisionSimulation: React.FC = () => {
	const { t } = useTranslation()
	const displayContent = useSelector(selectInDisplayContent)

	const data = displayContent?.data
	return (
		<Wrapper>
			<TitleWrapper>
				<FirstLine>{t('content.clinicalData')}</FirstLine>
				<SecondLine>{t('content.visionSimulation')}</SecondLine>
				<ThirdLine>{t('content.visionSimulationInfo')}</ThirdLine>
			</TitleWrapper>
			{isVisionSimulationContent(data) && (
				<ImagesBox className="vertical">
					<MediaBox media={data.content.both} direction="full" />
				</ImagesBox>
			)}
		</Wrapper>
	)
}

export default VisionSimulation
